export const TYPEFORM_MULTIPLE_URL =
	'https://t40tz85n2uw.typeform.com/tobbvallalkozas';
export const CAL_COM_MULTIPLE_URL =
	'https://cal.com/nikoletta-bodnar-bookeepie/tobbceges-ugyintezes-bokkeeepie-idopontfoglalas';
export const CAL_COM_KFT_URL =
	'https://cal.com/team/bookkeepie-magyarorszag/bookkeepie-ugyintezes-idopontfoglalas-delelott';
